import i18n from '@/plugins/i18n';

const metricsPSGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.bulk-operations'),
      header: {
        title: i18n.global.t('dbm.bulk-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_postgres_buffer_hits,meter_postgres_block_reads',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.no-of-count-minute'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.no-of-count-minute'),
      },
      showLegendForSeries: true,
    },

    {
      width: '48%',
      title: i18n.global.t('dbm.confis-operations'),
      header: {
        title: i18n.global.t('dbm.confis-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#2f67ff', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_postgres_queries_canceled_due_to_pinned_buffers,meter_postgres_queries_canceled_due_to_deadlocks,meter_postgres_queries_canceled_due_to_lock_timeouts,meter_postgres_queries_canceled_due_to_old_snapshots,meter_postgres_queries_canceled_due_to_dropped_tablespaces',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.no-of-count-minute'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.no-of-count-minute'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.tup-operations'),
      header: {
        title: i18n.global.t('dbm.tup-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#2f67ff', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_postgres_rows_deleted,meter_postgres_rows_fetched,meter_postgres_rows_inserted,meter_postgres_rows_returned,meter_postgres_rows_updated',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.no-of-count-minute'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.no-of-count-minute'),
      },
      showLegendForSeries: true,
    },

    {
      width: '48%',
      title: i18n.global.t('dbm.xact-operations'),
      header: {
        title: i18n.global.t('dbm.xact-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#2f67ff', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_postgres_transactions_committed,meter_postgres_transactions_rolled_back',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.no-of-count-minute'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.no-of-count-minute'),
      },
      showLegendForSeries: true,
    },
  ],
});

export default metricsPSGraphs;
